import styled from 'styled-components'
import { respondBelow } from '@rhinofi/dvf-shared-ui/lib/utils/respondTo'
import { NoUnderlineAnchor } from '../common/Helpers/LinkHelpers'

export const NavigationLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
`

export const NavigationLinksContent = styled.div`
  display: flex;
  gap: 28px;

  @media ${respondBelow('xs')} {
    gap: 12px;
  }
`

export const NavigationSubHref = styled(NoUnderlineAnchor)`
  padding: 8px 0;
  color: ${({ theme }) => theme.textPrimary};
  font-size: 13px;
  border: 1px solid transparent;
  transition: all 0.15s ease-out;

  &:hover,
  &:focus,
  &:active {
    opacity: 0.8;
  }
`

export const NavigationSubLinksContent = styled.div`
  min-width: 148px;
  padding: 0 8px;
`
